export const SENSITIVE_DATA_IDS = 'mspaSensitiveDataPurposeIds';
export const OPT_OUT_PURPOSE_IDS = 'mspaPurposeIds';
export const SENSITIVE_DATA_PROCESSING = 'mspaSensitiveDataProcessing';
export const CHILDREN_DATA_PROCESSING = 'mspaChildSensitiveDataProcessing';
export const AUTO_POPUP = 'mspaAutoPopUp';
